exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popularMobile__row___1wiug {\n  margin-top: 20px; }\n", ""]);

// exports
exports.locals = {
	"row": "popularMobile__row___1wiug"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/HomePage/PopularCategories/PopularMobile/popularMobile.scss
// module id = 4902
// module chunks = 6